module.exports = __webpack_public_path__ + "img/validation.bc4808af.svg";